import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Wordmark, T, F, Btn } from '../lib/bricks';
import ProgressReportPaper from '../components/developer/ProgressReportPaper';
import { shortDate } from '../components/developer/siteShareModel';
import BricksLoader from '../components/BricksLoader';

const CSS = `
.rs-bar{max-width:1040px;margin:0 auto;padding:0 56px;box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:64px}
@media (max-width:719px){.rs-bar{padding:0 20px}}
`;

// Public, read-only progress report for a builder's lender or investors.
export default function ProgressReportSharePage() {
  const { token } = useParams();
  const [view, setView] = useState(null);
  const [error, setError] = useState('');
  const BASE = process.env.REACT_APP_BACKEND_URL;
  const api = `${BASE}/api/dev/report-share/${encodeURIComponent(token)}`;

  useEffect(() => {
    let live = true;
    fetch(api)
      .then(async (r) => {
        if (!r.ok) {
          let detail = r.status === 404 ? 'This link is invalid, expired or was turned off.' : 'This page is unavailable right now. Try again shortly.';
          try { const b = await r.json(); if (typeof b?.detail === 'string') detail = b.detail; } catch { /* keep */ }
          throw new Error(detail);
        }
        return r.json();
      })
      .then((d) => { if (live) setView(d); })
      .catch((e) => { if (live) setError(e.message || 'This page is unavailable right now.'); });
    return () => { live = false; };
  }, [api]);

  const until = view?.share?.expires_at ? shortDate(view.share.expires_at) : '';
  return (
    <div data-report-surface="" style={{ minHeight: '100vh', background: 'var(--c-bg)', color: 'var(--c-ink)', fontFamily: F.display, overflowX: 'clip', paddingBottom: 'calc(48px + env(safe-area-inset-bottom, 0px))' }}>
      <style>{CSS}</style>
      <div style={{ borderBottom: `1px solid var(--c-hair-s)` }}>
        <div className="rs-bar">
          {view ? (
            <span data-testid="report-share-until" style={{ fontSize: 12.5, color: 'var(--c-ink-mute)', minWidth: 0 }}>{until ? `Read-only link · valid until ${until}` : 'Read-only link'}</span>
          ) : (
            <a href="https://www.brxs.ca" aria-label="Bricks" style={{ display: 'inline-flex', minHeight: 44, alignItems: 'center' }}><Wordmark size={18} color="var(--c-ink)" /></a>
          )}
          {view ? (
            <Btn variant="accent" as="a" href={`${api}/pdf`} style={{ minHeight: 44, padding: '0 16px', fontSize: 13, whiteSpace: 'nowrap' }} data-testid="share-download">Download PDF</Btn>
          ) : <span style={{ fontSize: 12.5, color: 'var(--c-ink-mute)' }}>Shared update</span>}
        </div>
      </div>
      {error ? (
        <div data-testid="report-share-error" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px' }}>
          <div style={{ maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <h1 style={{ margin: 0, fontSize: 32, fontWeight: 300, letterSpacing: '-0.02em' }}>This link isn’t available</h1>
            <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--c-ink-mute)' }}>{error} Ask the person who shared it for a new link.</p>
          </div>
        </div>
      ) : !view ? (
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <BricksLoader variant="assemble" size={40} color="currentColor" label="Loading report" />
        </div>
      ) : (
        <main><ProgressReportPaper view={view} /></main>
      )}
    </div>
  );
}
